<template>
  <div>
    <tool-bar
      :title="toolbarTitle"
      :show-right-menu="showToolbarMenu"
      :right-menu-actions="toolbarActionsList"
      @onActionSelected="onToolbarActionSelected"
      :showSubTitle="false"
      :showLenderCobrandingData="false"
    ></tool-bar>

    <redirecting-message-dialog
      :show="showRedirectMessageDialog"
      ref="redirectMessageDialog"
      @onRedirect="onRedirectPartnerApp"
      @onRedirectionCancelled="onRedirectionCancelled"
    ></redirecting-message-dialog>

    <login-item
      class="margin_top_40"
      ref="login"
      :show="showLoginItem"
      @onLoggedIn="onLoggedIn"
    ></login-item>

    <lead-data-check-item
      class="margin_top_40"
      ref="leadDataCheck"
      :show="showLeadDataCheckItem"
      @onLeadDataValid="onLeadDataValid"
      @onLoginAgain="onLoginAgainFromLeadDataCheck"
      @onDismiss="onLoginAgainFromLeadDataCheck"
      @onContinueOnSameDeviceWithSecondaryMobile="onContinueOnSameDeviceWithSecondaryMobile"
    ></lead-data-check-item>

    <applied-loans-check-item
      class="margin_top_20"
      ref="appliedLoansCheck"
      :show="showAppliedLoansCheckItem"
      :retailer-short-name="retailerShortName"
      :office-external-id="officeExternalId"
      @onApplyNewLoan="onApplyNewLoan"
      @onContinueWithExistingLoan="onContinueWithExistingLoan"
    ></applied-loans-check-item>
  </div>
</template>

<script>
import ToolBar from "../../layout/ToolBar";
import LoginItem from "../../layout/LoginItem";
import RedirectingMessageDialog from "../../dialogs/RedirectingMessageDialog";
import ActivityNavigator, { Activities } from "../../../utils/ActivityNavigator";
import EzUtils from "../../../utils/EzUtils";
import PrefManager from "../../../data/model/PrefManager";
import LoanScopeDataHolder from "../../../data/model/LoanScopeDataHolder";
import UrlParams from "../../../data/model/UrlParams";
import LeadDataCheckItem from "../../layout/LeadDataCheckItem";
import AppliedLoansCheckItem from "../../layout/AppliedLoansCheckItem";
import PartnerAppParam from "../../../data/model/PartnerAppParam";
import { RolesConstants } from "../../../utils/RolesConstants";
import AuthenticationInterceptor from "../../core/authentication/AuthenticationInterceptor";
import { ToolbarMenuItems } from "../../../utils/ToolbarMenuItems";

const MERCHANT = "MERCHANT";

export default {
  name: "LoginActivity",
  components: {
    ToolBar,
    LoginItem,
    LeadDataCheckItem,
    AppliedLoansCheckItem,
    RedirectingMessageDialog
  },
  data: () => ({
    phoneNumber: "",
    retailerShortName: "",
    officeExternalId: "",
    showLoginItem: false,
    loginWithPhoneNumberAllowed: true,
    loginWithUsernameAllowed: true,
    showLeadDataCheckItem: false,
    showAppliedLoansCheckItem: false,
    showToolbarMenu: false,
    showRedirectMessageDialog: false
  }),
  methods: {
    onToolbarActionSelected(selectedAction) {
      if (ToolbarMenuItems.GO_TO_MERCHANT_APP === selectedAction) {
        this.showRedirectMessageDialog = true;
        this.$refs.redirectMessageDialog.initializeDialog();
      }
    },

    onRedirectPartnerApp() {
      if (PartnerAppParam.isPartnerCallbackWithJavaScriptInterface()) {
        // eslint-disable-next-line no-undef
        partnerCallback.openPartnerApp();
      } else {
        window.location = "https://stage-finance.piggyride.in/app/v1/redirect";
      }
    },

    onRedirectionCancelled() {
      this.showRedirectMessageDialog = false;
    },

    resetViewItems() {
      this.showLoginItem = false;
      this.showLeadDataCheckItem = false;
      this.showAppliedLoansCheckItem = false;
    },

    onLeadDataValid(leadDetails) {
      LoanScopeDataHolder.setLeadDetails(leadDetails);
      this.appliedLoansItem();
    },

    onLoginAgainFromLeadDataCheck() {
      this.phoneNumber = "";
      this.loginItem();
    },

    onContinueOnSameDeviceWithSecondaryMobile(secondaryMobileNumber) {
      this.phoneNumber = secondaryMobileNumber;
      this.loginItem();
    },

    loginItem() {
      this.resetViewItems();
      this.showLoginItem = true;
      this.loginWithUsernameAllowed = !this.isOnboardingProcess;
      this.$refs.login.showLoginView(
        this.loginWithUsernameAllowed,
        this.loginWithPhoneNumberAllowed,
        this.phoneNumber
      );
    },

    leadDataCheckItem(leadId, mobileNumber) {
      this.resetViewItems();
      LoanScopeDataHolder.setLeadDetails(null);
      this.showLeadDataCheckItem = true;
      this.$refs.leadDataCheck.checkForLeadDataValidation(leadId, mobileNumber);
    },

    appliedLoansItem() {
      this.resetViewItems();
      this.showAppliedLoansCheckItem = true;
      this.$refs.appliedLoansCheck.checkForAvailableLoans();
    },

    onApplyNewLoan() {
      LoanScopeDataHolder.setMobile(PrefManager.getUserMobile());
      let nextActivity = Activities.LOAN_PRODUCT_DETAILS;
      const merchantId = LoanScopeDataHolder.getMerchantID();
      if (LoanScopeDataHolder.getLeadDetails()) {
        const leadDetails = LoanScopeDataHolder.getLeadDetails();
        if (leadDetails) {
          const retailerName = leadDetails.partner_name;
          if (retailerName && retailerName.toString().toLowerCase().includes("airtel")) {
            const leadDetailsData = leadDetails.data
                ? EzUtils.convertToJSONObjectIfString(leadDetails.data)
                : {};

            const loanAmount = EzUtils.isAValidNumber(leadDetailsData.loanAmount)
                ? Number(leadDetailsData.loanAmount).toFixed(0).toString()
                : (EzUtils.isAValidNumber(leadDetailsData.productPrice)
                        ? Number(leadDetailsData.productPrice).toFixed(0).toString()
                        : 0
                );

            const category = leadDetails.category;
            const brand = leadDetails.brand;
            const model = leadDetails.model;

            if (loanAmount > 0 && category && brand && model) {
              nextActivity = Activities.CLIENT_DETAILS;
              LoanScopeDataHolder.setProductCategory(category);
              LoanScopeDataHolder.setBrand(brand);
              LoanScopeDataHolder.setModel(model);
              LoanScopeDataHolder.setLoanAmount(loanAmount);
            }
          }
        }
      }
      this.openActivity(nextActivity);
    },

    onContinueWithExistingLoan(loanId) {
      LoanScopeDataHolder.setLoanId(loanId);
      this.openActivity(Activities.LOAN_DETAILS);
    },

    onLoggedIn() {
      if (UrlParams.getLoanAccountNumber()) {
        LoanScopeDataHolder.setLoanAccountNumber(UrlParams.getLoanAccountNumber());
        this.openActivity(Activities.LOAN_DETAILS);
        return;
      }

      if (this.isAgent) {
        this.openActivity(Activities.OFFICE);
      } else if (EzUtils.isValidId(UrlParams.getLeadId())) {
        this.leadDataCheckItem(UrlParams.getLeadId(), PrefManager.getUserMobile());
      } else if (UrlParams.getMerchantID()) {
        LoanScopeDataHolder.setMerchantID(UrlParams.getMerchantID());
        this.appliedLoansItem();
      } else {
        this.openActivity(Activities.HOME);
      }
    },

    openActivity(activity) {
      ActivityNavigator.navigateTo(activity);
    }
  },

  created() {
    AuthenticationInterceptor.removeAllAuthorization();
  },

  mounted() {
    PrefManager.clearPrefs();
    LoanScopeDataHolder.clearLoanScopeData();

    LoanScopeDataHolder.setLeadEntity(UrlParams.getEntity());
    if (UrlParams.getMobile()) {
      LoanScopeDataHolder.setMobile(UrlParams.getMobile());
    }

    if (PartnerAppParam.isPartnerAppCallback()) {
      this.showToolbarMenu = true;
    }
    if (UrlParams.getMerchantID()) {
      this.officeExternalId = UrlParams.getMerchantID();
    }
    if (UrlParams.getMobile()) {
      this.phoneNumber = UrlParams.getMobile();
    }
    this.loginItem();
  },

  computed: {
    toolbarTitle() {
      if (this.showLoginItem) {
        return "Login";
      } else if (this.showAppliedLoansCheckItem) {
        return LoanScopeDataHolder.isOnboardingLoan()
          ? "Onboarding Loan"
          : "Apply Loan";
      } else {
        return "";
      }
    },

    toolbarActionsList() {
      return this.showToolbarMenu && PartnerAppParam.isPartnerAppCallback()
        ? [ToolbarMenuItems.GO_TO_MERCHANT_APP]
        : [];
    },

    isAgent() {
      return PrefManager.doesUserHasRole(RolesConstants.AGENT);
    },

    isOnboardingProcess() {
      return LoanScopeDataHolder.isOnboardingLoan();
    },
  }
}
</script>

<style scoped src="../../../assets/style/base.css"></style>
